import React from 'react'
import {TwChips} from '@components/common/base/chips/containers'
import {ChipsProps} from '@components/common/base/chips/types'

export const Chips = ({children, onClick, className, active}: ChipsProps) => (
  <TwChips
    $forceState={active ? 'active' : undefined}
    className={className}
    onClick={onClick}
  >
    {children}
  </TwChips>
)
